class UsersController {
    static controller($scope, $localStorage, $rootScope) {
        'ngInject';

        $scope.cokiesInfoShowed = $localStorage.cokiesInfoShowed;
        
        $scope.closeCookiesInfo = function() {
            $localStorage.cokiesInfoShowed = true;
            $scope.cokiesInfoShowed = true;
        }
    }
}

export default UsersController.controller;



// WEBPACK FOOTER //
// ./src/users/users.controller.js